import api from './api';

/**
 * Service for managing users in the system
 */
const userService = {
  /**
   * Get all users
   * @returns {Promise} Promise object containing the users array
   */
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  /**
   * Get a user by ID
   * @param {string|number} id User ID
   * @returns {Promise} Promise object containing the user data
   */
  getUserById: async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
  },

  /**
   * Create a new user
   * @param {Object} userData User data object containing email, password, name, and role
   * @returns {Promise} Promise object containing the created user data
   */
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  /**
   * Update an existing user
   * @param {string|number} id User ID
   * @param {Object} userData User data object with fields to update
   * @returns {Promise} Promise object containing the updated user data
   */
  updateUser: async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
  },

  /**
   * Delete a user
   * @param {string|number} id User ID to delete
   * @returns {Promise} Promise object with deletion status
   */
  deleteUser: async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
  },

  /**
   * Get all available roles in the system
   * @returns {Promise} Promise object containing the roles array
   */
  getRoles: async () => {
    const response = await api.get('/users/roles');
    return response.data;
  }
};

export default userService;
